var _defs, _rect, _rect2, _text, _text2, _text3, _g, _rect3, _text4, _text5, _g2, _polyline, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _rect4, _text19, _g3, _text20;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCase04HeroBigdata(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 900,
    viewBox: "0 0 1600 900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hbg",
    x1: 0,
    x2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#102f1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#286a3e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "panel",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4f8f5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 18,
    stdDeviation: 20,
    floodOpacity: 0.2
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "#edf5ef"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 315,
    fill: "url(#hbg)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 68,
    fontFamily: "sans-serif",
    fontSize: 20,
    fontWeight: 800,
    letterSpacing: 3,
    fill: "#a9dfba"
  }, "STOMATAL BIG DATA / 2026.01.21")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 145,
    fontFamily: "sans-serif",
    fontSize: 55,
    fontWeight: 800,
    fill: "#fff"
  }, "18,582\u500B\u306E\u6C17\u5B54\u304B\u3089\u3001\u4F55\u304C\u898B\u3048\u308B\uFF1F")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 200,
    fontFamily: "sans-serif",
    fontSize: 24,
    fill: "#d7e8dc"
  }, "RAW \u2192 IMAGE \u2192 HOUR \u2192 ENVIRONMENT \u2192 REGRESSION \u2192 IRRIGATION")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 55,
    width: 155,
    height: 150,
    rx: 22,
    fill: "white"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1050,
    y: 112,
    fontFamily: "sans-serif",
    fontSize: 38,
    fontWeight: 800,
    fill: "#267344"
  }, "538"), /*#__PURE__*/React.createElement("text", {
    x: 1050,
    y: 148,
    fontFamily: "sans-serif",
    fontSize: 17,
    fill: "#6c7a71"
  }, "images"), /*#__PURE__*/React.createElement("rect", {
    x: 1190,
    y: 55,
    width: 170,
    height: 150,
    rx: 22,
    fill: "white"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1218,
    y: 112,
    fontFamily: "sans-serif",
    fontSize: 38,
    fontWeight: 800,
    fill: "#267344"
  }, "18,582"), /*#__PURE__*/React.createElement("text", {
    x: 1218,
    y: 148,
    fontFamily: "sans-serif",
    fontSize: 17,
    fill: "#6c7a71"
  }, "stomata"), /*#__PURE__*/React.createElement("rect", {
    x: 1375,
    y: 55,
    width: 155,
    height: 150,
    rx: 22,
    fill: "white"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1405,
    y: 112,
    fontFamily: "sans-serif",
    fontSize: 38,
    fontWeight: 800,
    fill: "#267344"
  }, "519"), /*#__PURE__*/React.createElement("text", {
    x: 1405,
    y: 148,
    fontFamily: "sans-serif",
    fontSize: 17,
    fill: "#6c7a71"
  }, "morphology images"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 350,
    width: 1030,
    height: 490,
    rx: 32,
    fill: "url(#panel)",
    stroke: "#d6e2da",
    strokeWidth: 3
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 405,
    fontFamily: "sans-serif",
    fontSize: 19,
    fontWeight: 800,
    letterSpacing: 2,
    fill: "#33784d"
  }, "DAILY MORPHOLOGY")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 448,
    fontFamily: "sans-serif",
    fontSize: 31,
    fontWeight: 800,
    fill: "#17251d"
  }, "\u753B\u50CF\u5225\u4E2D\u592E\u5024\u30921\u6642\u9593\u5358\u4F4D\u3078\u52A0\u5DE5")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#dfe8e2",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: 500,
    x2: 992,
    y2: 500
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: 560,
    x2: 992,
    y2: 560
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: 620,
    x2: 992,
    y2: 620
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: 680,
    x2: 992,
    y2: 680
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "92.0,605.0 182.0,601.6 272.0,577.5 362.0,548.6 452.0,532.2 542.0,509.3 632.0,486.3 722.0,561.8 812.0,560.0 902.0,592.1 992.0,599.2",
    fill: "none",
    stroke: "#267344",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 605,
    r: 9,
    fill: "#267344"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 182,
    cy: 601.6,
    r: 9,
    fill: "#267344"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 272,
    cy: 577.5,
    r: 9,
    fill: "#267344"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 548.6,
    r: 9,
    fill: "#267344"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 452,
    cy: 532.2,
    r: 9,
    fill: "#267344"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 542,
    cy: 509.3,
    r: 9,
    fill: "#267344"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 632,
    cy: 486.3,
    r: 9,
    fill: "#267344"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 722,
    cy: 561.8,
    r: 9,
    fill: "#267344"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 812,
    cy: 560,
    r: 9,
    fill: "#267344"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 902,
    cy: 592.1,
    r: 9,
    fill: "#267344"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 992,
    cy: 599.2,
    r: 9,
    fill: "#267344"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 720,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 16,
    fill: "#66746c"
  }, "07")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 720,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 16,
    fill: "#66746c"
  }, "08")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 272,
    y: 720,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 16,
    fill: "#66746c"
  }, "09")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 362,
    y: 720,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 16,
    fill: "#66746c"
  }, "10")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 720,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 16,
    fill: "#66746c"
  }, "11")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 542,
    y: 720,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 16,
    fill: "#66746c"
  }, "12")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 632,
    y: 720,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 16,
    fill: "#66746c"
  }, "13")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 722,
    y: 720,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 16,
    fill: "#66746c"
  }, "14")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 812,
    y: 720,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 16,
    fill: "#66746c"
  }, "15")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 902,
    y: 720,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 16,
    fill: "#66746c"
  }, "16")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 992,
    y: 720,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 16,
    fill: "#66746c"
  }, "17")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 780,
    fontFamily: "sans-serif",
    fontSize: 19,
    fill: "#67756d"
  }, "Aperture 2.71 \u2192 6.48 \u2192 2.89 \xB5m")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 780,
    fontFamily: "sans-serif",
    fontSize: 19,
    fill: "#67756d"
  }, "Open\u7387\u30FBArea\u30FBShort/Long\u3082\u540C\u6642\u306B\u96C6\u8A08")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 350,
    width: 425,
    height: 490,
    rx: 32,
    fill: "#163d25"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 1160,
    y: 405,
    fontFamily: "sans-serif",
    fontSize: 18,
    fontWeight: 800,
    letterSpacing: 2,
    fill: "#9dd5ae"
  }, "ANALYSIS PIPELINE")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "sans-serif"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1175,
    cy: 475,
    r: 18,
    fill: "#b6e0c2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1170,
    y: 482,
    fontSize: 19,
    fontWeight: 800,
    fill: "#163d25"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    x: 1210,
    y: 483,
    fontSize: 24,
    fontWeight: 800,
    fill: "#fff"
  }, "\u6C17\u5B54\u5358\u4F4D"), /*#__PURE__*/React.createElement("line", {
    x1: 1175,
    y1: 500,
    x2: 1175,
    y2: 540,
    stroke: "#7bb98e",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1175,
    cy: 565,
    r: 18,
    fill: "#b6e0c2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1170,
    y: 572,
    fontSize: 19,
    fontWeight: 800,
    fill: "#163d25"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    x: 1210,
    y: 573,
    fontSize: 24,
    fontWeight: 800,
    fill: "#fff"
  }, "\u753B\u50CF\u5358\u4F4D"), /*#__PURE__*/React.createElement("line", {
    x1: 1175,
    y1: 590,
    x2: 1175,
    y2: 630,
    stroke: "#7bb98e",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1175,
    cy: 655,
    r: 18,
    fill: "#b6e0c2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1170,
    y: 662,
    fontSize: 19,
    fontWeight: 800,
    fill: "#163d25"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    x: 1210,
    y: 663,
    fontSize: 24,
    fontWeight: 800,
    fill: "#fff"
  }, "1\u6642\u9593\u5358\u4F4D"), /*#__PURE__*/React.createElement("line", {
    x1: 1175,
    y1: 680,
    x2: 1175,
    y2: 720,
    stroke: "#7bb98e",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1175,
    cy: 745,
    r: 18,
    fill: "#b6e0c2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1170,
    y: 752,
    fontSize: 19,
    fontWeight: 800,
    fill: "#163d25"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    x: 1210,
    y: 753,
    fontSize: 24,
    fontWeight: 800,
    fill: "#fff"
  }, "\u74B0\u5883\u30FB\u704C\u6C34\u3068\u7D71\u5408"))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 1160,
    y: 805,
    fontFamily: "sans-serif",
    fontSize: 18,
    fill: "#bed2c4"
  }, "\u554F\u3044\u306B\u5408\u308F\u305B\u3066\u3001\u6307\u6A19\u3068\u7C92\u5EA6\u3092\u5909\u3048\u308B\u3002")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase04HeroBigdata);
export default __webpack_public_path__ + "static/media/case04-hero-bigdata.5bf3a37eec778b14c438f6528288f86e.svg";
export { ForwardRef as ReactComponent };